var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "8", height: "16", viewBox: "0 0 8 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.70308 13.905C8.13949 14.43 8.08895 15.2281 7.59019 15.6874C7.09143 16.1468 6.33331 16.0936 5.8969 15.5686L0.296907 8.83179C-0.0989691 8.35555 -0.0989691 7.64445 0.296907 7.16821L5.8969 0.431379C6.33331 -0.0936346 7.09143 -0.146836 7.59019 0.312551C8.08895 0.771938 8.13949 1.56995 7.70308 2.09497L2.79452 8L7.70308 13.905Z", fill: "#303030" })
  );
});